const SUBSCRIBER = 'SUBSCRIBER'

export { SUBSCRIBER }
